
  import {getMetaTags} from '@/helper/Seo';
  import {mapSectionComponents} from '@/helper/SectionHelper';
  import LazyHydrate from 'vue-lazy-hydration';
  import {scopeHelper} from '@/helper/ScopeHelper';
  import axios from 'axios';

  export default {
    name: 'Wiki',
    components: {
      LazyHydrate,
    },
    async asyncData({error, route, $cachedStrapi, redirect, app}) {
      // Query page from Strapi; strapi-change for findOne is required!
      const pagePromise = $cachedStrapi
        .findOne('pages', 'wikis-slug')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      // Query Wiki from Strapi based on slug; strapi-change for findOne is required!
      const wikiPromise = $cachedStrapi
        .findOne('wikis', route.params.slug)
        .catch(async () => {
          const slug = route.params.slug;
          const currentQuery = route.query;
          const response = await axios.get(process.env.STRAPI_URL + '/wikis', {
            params: {
              slug,
              _publicationState: 'preview',
            },
          });
          if (response.data.length > 0) {
            const newQueryParam = {
              ...currentQuery,
              mtm_group: 'wiki-deactivated',
            };

            const redirectRoute = app.localePath({
              name: 'wikis',
              query: newQueryParam,
            });

            // Redirect the user to the main listing page (with status code 302)
            redirect(301, redirectRoute);
          } else {
            const newQueryParam = {
              ...currentQuery,
              mtm_group: 'wiki-not-found',
            };

            const redirectRoute = app.localePath({
              name: 'wikis',
              query: newQueryParam,
            });

            // Redirect the user to the main listing page (with status code 301)
            redirect(302, redirectRoute);
          }
          return;
        });

      const [page, wiki] = await Promise.all([pagePromise, wikiPromise]);

      if (
        !scopeHelper(page, process.env.SCOPE_CANDIDATE) ||
        !scopeHelper(wiki, process.env.SCOPE_CANDIDATE)
      ) {
        error({statusCode: 404, message: 'Wiki not found'});
        return;
      }

      const sections = await mapSectionComponents(
        page.sections,
        async function (section) {
          switch (section.component) {
            case 'SectionWikiDetails':
              section.wiki = wiki;
              break;

            case 'SectionHomepageJobBoxWithTabs':
            case 'SectionJobBoxWithoutTabs':
              if (!wiki.filterParams) {
                section.filterParams = {};
              }
              section.filterParams = wiki.filterParams;

              if (section.base_data && section.base_data.title) {
                section.base_data.title = section.base_data.title.replace(
                  /%wiki_name/g,
                  wiki.title.toUpperCase()
                );
              }

              if (section.base_data && section.base_data.intro_text) {
                section.base_data.intro_text =
                  section.base_data.intro_text.replace(
                    /%wiki_name/g,
                    wiki.title
                  );
              }

              if (section.base_data && section.base_data.finish_text) {
                section.base_data.finish_text =
                  section.base_data.finish_text.replace(
                    /%wiki_name/g,
                    wiki.title
                  );
              }
              break;

            case 'SectionBreadcrumbs':
              section.breadcrumbs = [
                {
                  text: app.i18n.t('page.index'),
                  disabled: false,
                  to: app.localePath({
                    name: 'index',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: app.i18n.t('page.wikis'),
                  disabled: false,
                  to: app.localePath({
                    name: 'wikis',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: wiki.title,
                  disabled: true,
                  to: app.localePath({
                    name: 'wikis-slug',
                    params: {
                      slug: wiki.slug,
                    },
                  }),
                  nuxt: true,
                  exact: true,
                },
              ];
              break;

            case 'SectionSeoContent':
              if (
                wiki.seo_content_config &&
                wiki.seo_content_config.seo_contents &&
                wiki.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  wiki.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        }
      );

      const metaData =
        wiki && wiki.meta ? wiki.meta : page && page.meta ? page.meta : {};

      return {
        metaData,
        sections,
      };
    },
    data() {
      return {
        metaData: {},
        sections: [],
      };
    },
    head() {
      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
      };
    },
  };
